<template lang="pug">
div
  v-card.round-xl.pa-4.mt-3(outlined)
    div.d-flex.align-center.fill-height
      div.handle(:class="{ 'drag-active': drag, 'drag-inactive': !drag }")
        v-icon(color="neutral500") $yzi-dots-grid-02
      div.ml-4
        div.text-md.font-medium.neutral700--text {{ service.name }}
          span.ml-2.mr-1(v-for="category in service.categories")
            v-chip.text-xs.neutral500--text.font-normal.px-2(small label color="neutral300") {{ category.name }}
        div.text-sm.neutral700--text.mt-1 {{ $t('booking_fee') }}: {{ service.booking_fee | displayPrice($currency) }}
        div.text-sm.neutral500--text {{ $t('duration') }}: {{ service.duration_value }} {{ service.duration_unit }}
      v-spacer
      div
        y-switch.mb-n2(v-model="service.enabled" @change="changeStatus(service)")
      v-menu(offset-y left rounded="lg" attach)
        template(#activator="{ on }")
          v-btn.ml-4(icon small v-on="on")
            v-icon mdi-dots-horizontal
        v-list.py-0
          v-list-item(@click="editService(service)")
            v-list-item-title.text-sm.basic800--text.font-normal {{ $t('edit_service') }}
          template(v-if="service.categories.length")
            v-divider
            v-list-item(@click="showEditDialog = true")
              v-list-item-title.text-sm.basic800--text.font-normal {{ $t('reassign_category') }}
            v-divider
            v-list-item(@click="showDeleteCategoryDialog = true")
              v-list-item-title.text-sm.basic800--text.font-normal {{ $t('remove_from_category') }}
          template(v-else)
            v-divider
            v-list-item(@click="showEditDialog = true")
              v-list-item-title.text-sm.basic800--text.font-normal {{ $t('assign_to_category') }}
          v-divider
          v-list-item(@click="showDeleteDialog = true")
            v-list-item-title.text-sm.danger500--text.font-normal {{ $t('delete_service') }}

  .dialogs
    delete-service-dialog(v-if="showDeleteDialog" :open.sync="showDeleteDialog" :service="service" @deleted="successDeleteService")
    edit-service-category-dialog(v-if="showEditDialog" :open.sync="showEditDialog" :service="service" @edited="successEditService")
    delete-service-category-dialog(v-if="showDeleteCategoryDialog" :open.sync="showDeleteCategoryDialog" :service="service" @deleted="successEditService")

</template>

<script>
import { mapActions } from 'vuex'
import DeleteServiceDialog from '@/components/clinic/dialogs/DeleteServiceDialog.vue'
import EditServiceCategoryDialog from '@/components/clinic/dialogs/EditServiceCategoryDialog.vue'
import DeleteServiceCategoryDialog from '@/components/clinic/dialogs/DeleteServiceCategoryDialog.vue'
import draggable from 'vuedraggable'

export default {
  name: 'ManageServiceItem',
  components: { DeleteServiceDialog, EditServiceCategoryDialog, DeleteServiceCategoryDialog, draggable },
  props: ['service', 'company', 'drag'],
  data: () => ({
    showDeleteDialog: false,
    showEditDialog: false,
    showDeleteCategoryDialog: false
  }),
  methods: {
    ...mapActions(['showMessage']),
    changeStatus (service) {
      this.$axios.patch(`/clinics/${this.company.slug}/services/${service.id}`, { product: { status: service.enabled ? 'published' : 'draft' }})
        .then(resp => {
          this.$set(service, 'status', resp.data.product.status)
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    editService (service) {
      this.$router.push(`/admin/clinic/manage/appointment-service/${service.id}`)
    },
    deleteService () {
      this.showDeleteDialog = true
    },
    successDeleteService () {
      this.$emit('deleted')
    },
    successEditService () {
      this.$emit('edited')
    }
  }
}
</script>

<style scoped>
.drag-inactive { cursor: grab; }
.drag-active { cursor: grabbing; }
</style>